import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { DashboardsContainer } from '../dashboard';



export const HomeDashboardPage: React.FC = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;
    const homeId = Number(params.homeId);

    const { state:dataState } = useContext(ritzDataContext);
    const project = selectProjectById(dataState, projectId);

    const routeContext = useMemo(() => {
        return {
            userId,
            homeId,
        };
    }, [homeId, userId]);


    return (
        <div className={clsx('page-main-content')}>
            {project && (
                <DashboardsContainer projectId={projectId} routeContext={routeContext} />
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
